<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import DealKanbanColumn from './DealKanbanColumn.vue';

const props = defineProps({
  columns: {
    type: Array,
    default: () => [],
  },
  isMoving: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['moveStage']);

const { t } = useI18n();

const isEmpty = computed(() => props.columns.length === 0);

const handleMoveStage = (dealId, stageId) => {
  emit('moveStage', dealId, stageId);
};
</script>

<template>
  <div class="flex h-full">
    <div
      v-if="isEmpty"
      class="flex items-center justify-center w-full text-sm text-slate-500 dark:text-slate-400"
    >
      {{ t('DEALS.KANBAN.EMPTY') }}
    </div>

    <div v-else class="flex gap-4 p-4 overflow-x-auto h-full">
      <DealKanbanColumn
        v-for="column in columns"
        :key="column.stage.id"
        :stage="column.stage"
        :deals="column.deals"
        :is-moving="isMoving"
        @move-stage="handleMoveStage"
      />
    </div>
  </div>
</template>
